<template>
    <div id="TheToolbar">
        <v-toolbar color="primary" dark fixed app clipped-right>
            <v-toolbar-side-icon v-on:click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn flat to="/request">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    {{$t(applyRequestBtnText)}}
                </v-btn>
                <v-btn flat to="/user">{{$t('Профиль')}}</v-btn>
                <slot name="locale"></slot>
            </v-toolbar-items>
        </v-toolbar>
        <v-navigation-drawer fixed v-model="drawer" app width="350">
            <v-list>
                <v-list-group
                    v-for="item in groupedMenuItems"
                    :key="item.meta.parentItemName"
                    :prepend-icon="item.meta.titleIcon"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-badge>
                                    <template v-slot:badge>
                                        <span>{{abbreviateNumber(item.meta.valueCount)}}</span>
                                    </template>
                                    <v-list-tile-title class="subheading">{{ $t(item.meta.title) }}</v-list-tile-title>
                                </v-badge>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                    <v-list-tile v-for="subItem in item.items" :key="subItem.id" :to="subItem.path">
                        <v-list-tile-content>
                            <v-badge>
                                <template v-slot:badge>
                                    <span>{{abbreviateNumber(subItem.meta.valueCount)}}</span>
                                </template>
                                <v-list-tile-title>{{ $t(subItem.meta.title) }}</v-list-tile-title>
                            </v-badge>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-icon>{{ subItem.meta.titleIcon }}</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list-group>
            </v-list>
            <v-list>
                <v-list-tile v-for="item in rootMenuItems" :key="item.id" :to="item.path">
                    <v-list-tile-content>
                        <v-list-tile-title class="subheading">{{ $t(item.meta.title) }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-icon>{{ item.meta.titleIcon }}</v-icon>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
/*
Основное меню - верхняя панель и боковая панель навигации.
Входные параметры:
  title - заголовок.
  menuItems - для отображения меню в панели навигации.

*/
import { abbreviateNumber } from '../utility/routines';

export default {
    name: 'TheToolbar',

    data: () => ({
        drawer: false
    }),

    props: {
        title: {
            type: String,
            default: 'Заголовок'
        },
        applyRequestBtnText: {
            type: String
        },
        menuItems: {
            type: Array
        }
    },
    computed: {
        // только пункты меню с вложеными элементами
        // будут отображаться отдельной группой
        groupedMenuItems() {
            return this.menuItems.filter(item => {
                if (item.items) {
                    return true;
                }
            });
        },
        // только пункты меню без вложенных элементов
        // так называемые корневые пункты
        rootMenuItems() {
            return this.menuItems.filter(item => {
                if (!item.items) {
                    return true;
                }
            });
        }
    },
    methods: {
        abbreviateNumber: abbreviateNumber
    }
};
</script>
<style>
.v-badge__badge {
    padding-left: 3px !important;
    padding-right: 3px !important;
    width: initial !important;
    min-width: 22px !important;
}
</style>